module.exports = __webpack_public_path__ + "fonts/Sen-Bold.cc42b648.eot";